import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import user from "../../../assests/user.png";
import { Link, useNavigate } from "react-router-dom";

const JournalDesign = () => {
  const navigate = useNavigate();
    const handleScrollToTop = () => {
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });

        navigate("/editorial-board-journal-of-applied-bioanalysis")
      };
  return (
    <div>
    
      <Container fluid className="jab_homepage_section3_container p-lg-5 p-md-4 p-2">
        <Row className="align-items-center  py-3">
          <Col md={3} sm={6} xs={3} className="text-center">
         
            <img
              src={user}
             
              className=" p-2 jab_homepage_section3 mb-4"
              alt="Editor"
            />
          
          </Col>
          <Col md={6} sm={6}  xs={9} >
          <h2 className="text-warning mb-3">Editor-in-Chief</h2>
            <h4 className="mb-2">Ali S. Saad</h4>
            <p>
            Department of Biomedical Technology, College of Applied Medical Sciences, King Saud University Riyadh Saudi Arabia <br />
              Email: <a href="mailto:editor@journalofappliedbioanalysis.com" className="text-white "> editor@journalofappliedbioanalysis.com</a>
            </p>
            <Link to="editorial-board-journal-of-applied-bioanalysis" className="text-warning " onClick={handleScrollToTop}>
              View full Editorial Board
            </Link>
         
          </Col>
        </Row>
      </Container>
 
    </div>
  );
};

export default JournalDesign;
